export const ADD_QUIZ_REQUEST = "ADD_QUIZ_REQUEST";
export const ADD_QUIZ_SUCCESS = "ADD_QUIZ_SUCCESS";
export const ADD_QUIZ_FAILURE = "ADD_QUIZ_FAILURE";

export const GET_QUIZZES_BY_CHAPTER_ID_REQUEST =
  "GET_QUIZZES_BY_CHAPTER_ID_REQUEST";
export const GET_QUIZZES_BY_CHAPTER_ID_SUCCESS =
  "GET_QUIZZES_BY_CHAPTER_ID_SUCCESS";
export const GET_QUIZZES_BY_CHAPTER_ID_FAILURE =
  "GET_QUIZZES_BY_CHAPTER_ID_FAILURE";

export const DELETE_QUIZ_REQUEST = "DELETE_QUIZ_REQUEST";
export const DELETE_QUIZ_SUCCESS = "DELETE_QUIZ_SUCCESS";
export const DELETE_QUIZ_FAILURE = "DELETE_QUIZ_FAILURE";

export const CLEAR_QUIZ_ERRORS = "CLEAR_QUIZ_ERRORS";

export const DELETE_ALL_QUIZZES_FROM_CHAPTER_REQUEST = "DELETE_ALL_QUIZZES_FROM_CHAPTER_REQUEST";
export const DELETE_ALL_QUIZZES_FROM_CHAPTER_SUCCESS = "DELETE_ALL_QUIZZES_FROM_CHAPTER_SUCCESS";
export const DELETE_ALL_QUIZZES_FROM_CHAPTER_FAILURE = "DELETE_ALL_QUIZZES_FROM_CHAPTER_FAILURE";

export const UPSERT_QUIZZES_FOR_CHAPTER_REQUEST = "UPSERT_QUIZZES_FOR_CHAPTER_REQUEST";
export const UPSERT_QUIZZES_FOR_CHAPTER_SUCCESS = "UPSERT_QUIZZES_FOR_CHAPTER_SUCCESS";
export const UPSERT_QUIZZES_FOR_CHAPTER_FAILURE = "UPSERT_QUIZZES_FOR_CHAPTER_FAILURE";

export const GET_QUIZZES_BY_CHAPTER_REQUEST = "GET_QUIZZES_BY_CHAPTER_REQUEST";
export const GET_QUIZZES_BY_CHAPTER_SUCCESS = "GET_QUIZZES_BY_CHAPTER_SUCCESS";
export const GET_QUIZZES_BY_CHAPTER_FAILURE = "GET_QUIZZES_BY_CHAPTER_FAILURE";
